import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";

export default function Footer({ site }) {
  const s = site || {};
  return (
    <footer className="relative bg-[#080F22] text-slate-300 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            {s.logo_url && <img src={s.logo_url} alt="Be Hire Ready logo" className="h-11 w-11 rounded-lg ring-1 ring-white/10" />}
            <div>
              <div className="font-display text-lg text-white">Be Hire Ready</div>
              <div className="text-[10px] tracking-[0.24em] uppercase text-slate-400">Prepare · Improve · Succeed</div>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-md">{s.footer_desc}</p>
          <div className="mt-6 flex gap-3">
            <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"
               className="h-10 w-10 rounded-full grid place-items-center ring-1 ring-white/10 hover:bg-white/5 transition-colors">
              <Instagram size={16} />
            </a>
            <a href={`https://wa.me/${s.whatsapp}`} target="_blank" rel="noreferrer"
               className="px-4 h-10 rounded-full ring-1 ring-white/10 hover:bg-white/5 text-sm inline-flex items-center gap-2 transition-colors">
              <Phone size={14} /> WhatsApp
            </a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Explore</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href="/#programs" className="hover:text-white">Programs</a></li>
            <li><a href="/#skills" className="hover:text-white">Skills</a></li>
            <li><a href="/#founders" className="hover:text-white">Founders</a></li>
            <li><a href="/#colleges" className="hover:text-white">Colleges</a></li>
            <li><a href="/#employers" className="hover:text-white">Employers</a></li>
            <li><a href="/#contact" className="hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Reach us</div>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Phone size={14} /> {s.phone}</li>
            <li className="flex items-center gap-2"><MapPin size={14} /> {s.location}</li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms & Conditions</Link></li>
            <li><Link to="/admin/login" className="text-slate-500 hover:text-white text-xs">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/5 py-6 text-center text-xs text-slate-500">
        © 2026 Be Hire Ready. All Rights Reserved.
      </div>
    </footer>
  );
}
